<template>
       <div
              class="max-w-screen z-10 fixed mb-0 w-full flex justify-between items-center  bottom-0 border  bg-white shadow shadow-ody-gray_sm drop-shadow-sm   h-[3rem]">
              <div>

              </div>
              <div>
                     <div class="flex items-center md:order-2">
                            <Button text type="button" class="min-w-48 flex items-center gap-2" @click="toggle">
                                                        <span>{{ i18n.locale.value === 'fr' ? '🇫🇷' : '🇺🇸' }}</span>
                                                        <span>{{ currentLang.name }}</span>
                            </Button>

                            <Popover ref="op">
                                   <div class="flex flex-col gap-4">
                                          <div>
                                                 <span class="font-medium block mb-2">Select Language</span>
                                                 <ul class="list-none p-0 m-0 flex flex-col">
                                                        <li v-for="(lang, key) in language" :key="key" class="flex items-center gap-2 px-2 py-3 hover:bg-emphasis cursor-pointer rounded-border" @click="changeLang(key)">
                                                               <div>
                                                                      <span class="font-medium">{{ lang }}</span>
                                                               </div>
                                                        </li>
                                                 </ul>
                                          </div>
                                   </div>
                            </Popover>
                     </div>
              </div>
       </div>
</template>
<script lang="ts">

export default defineComponent({
       name: "Footer",
       setup() {
              const op = ref();
              const toggle = (event:any) => {
                     op.value.toggle(event);
              }
              const { locales, setLocale } = useI18n()
              const i18n = useI18n();
              const language = reactive({ fr: 'Francais', en: 'English (US)' });
              const currentLang = reactive({ name: i18n.locale.value == 'fr' ? language.fr : language.en });
              console.log('currentLang', i18n.locales.value);
              const changeLang = (key: 'fr' | 'en') => {
                     setLocale(key)  ;
                     currentLang.name = language[key];
                     op.value.hide();
              
              };

              return { language, currentLang, changeLang, i18n , toggle, op };
       }
});
</script>
<style scoped></style>